import { getOrgBackend } from "../../../app/backend";
import { TeamMember } from "../../../features/Booking-Form/typings/team-member";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";

export function useRemoteFetchFirstAidUsers() {
  return useRemoteMutation<Array<TeamMember & { id: string }>, RemoteApiError, void>({
    key: "fetch-firstAid-users",
    url: `${getOrgBackend()}/user-info/first-aid-users`,
    method: "get"
  });
}
